import React, { useContext, useEffect, useState } from 'react'

import { callApi } from 'api/utils'
import { useIsMobile } from 'hooks/useIsMobile'
import { uniqBy } from 'lodash'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'

import { PATHS } from '../api/paths'
import { getTogetherPath } from '../api/utils'
import { CardReply } from '../cardReply'
import { TogetherDataContext } from '../common/TogetherDataWrapper'
import { AskDoctorContext } from '../context'
import { Comment, Post } from '../interfaces/types'
import {
  LabelSorting,
  LabelSortingValue,
  useSortCommentChoices,
} from '../labelSortPin/labelSorting'
import { Section } from '../Section'
import { formatComment } from '../utils/dataTransform'
import { StyledCardPost } from './index.styled'

export type Props = {
  onDeletePost?: () => void
  handleCreateEditPost?: (v: Post) => void
}

const PostDetail = ({ onDeletePost, handleCreateEditPost, ...rest }: Props) => {
  const { formatMessage: f } = useIntl()
  const isMobile = useIsMobile()
  const router = useRouter()
  const { locale = 'vi-VN' } = router
  const { state: togetherDataState } = useContext(TogetherDataContext)
  const {
    selectedPost,
    setEditPostData,
    setShowPostForm,
    handleClosePopup,
    setShowPostDetailPopup,
  } = useContext(AskDoctorContext)
  const post =
    (selectedPost?.id && togetherDataState.postsById[selectedPost?.id]) || {}
  const [comments, setComments] = useState<Comment[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const {
    setSortChoiceValue,
    selectedSortChoice,
    sortedChoices,
  } = useSortCommentChoices()

  const fetchComment = async (config?: {
    page?: number
    isRefetch?: boolean
    sortValue?: string | number
  }) => {
    if (loading) return
    setLoading(true)
    try {
      const { page = 1, isRefetch, sortValue } = config || {}
      const sort = sortValue === LabelSortingValue.oldest ? 'oldest' : 'newest'

      // fetch next 10 replies
      if (post?.id) {
        const commentsRes = await callApi(
          getTogetherPath(PATHS.COMMENT.LIST, {
            postId: String(post.id),
            _locale: locale,
            page,
            sort,
          }),
          'GET',
        )
        const newData = commentsRes?.data?.comments?.map(formatComment) || []
        setComments((_old) =>
          uniqBy<Comment>(isRefetch ? newData : _old.concat(newData), 'id'),
        )
      }
    } catch (e) {
      console.error(e)
    }
    setLoading(false)
  }

  const refetchComment = async (comment: Comment) => {
    setComments((old) => {
      const foundIndex = old.findIndex((c) => c.id === comment.id)
      // comment.id = '-temp'
      old.splice(foundIndex, 1, comment)
      return old.slice()
    })
    // refetchComments()
  }

  const onPostCommentSuccess = (comment: Comment) => {
    setComments((old: any) => {
      // comment.id += '-temp'
      old.unshift(comment)
      return old.slice()
    })
    // setCommentsPagination((_old) => ({
    //   ..._old,
    //   total_items: _old.total_items + 1,
    // }))
    // togetherDataDispatch({
    //   type: PostActions.update,
    //   payload: {
    //     id: post.id,
    //     data: {
    //       commented: true,
    //     },
    //   },
    // })
    // refetchComments()
  }

  useEffect(() => {
    post?.id && fetchComment(post?.id)
  }, [post])

  let commentCount = comments.length || 0

  comments.map((i) => {
    commentCount += i.replies.length
  })

  return (
    <Section
      heading={f({
        id: 'askDoctor.heading',
        defaultMessage: 'Đặt câu hỏi cho bác sĩ',
      })}
      handleBackFn={() => {
        handleCreateEditPost?.({
          ...post,
          commentCount,
        })
        setShowPostDetailPopup(false)
      }}
      handleCloseFn={handleClosePopup}
      style={{
        zIndex: 10,
      }}
      {...rest}
    >
      <StyledCardPost
        isMobile={isMobile}
        className="main-post"
        disableCardLink
        title={post?.title}
        id={post?.id}
        slug={post?.slug}
        community={post?.community}
        author={post?.author}
        postDate={post?.createdDate}
        topics={post?.topics}
        photos={post?.photos}
        previewUrl={post?.previewUrl}
        description={post?.description}
        commentCount={commentCount}
        loveCount={post?.likeCount}
        // onCommentCountClick={() =>
        // sortRef.current?.scrollIntoView()
        // }
        isReplied={!Boolean(post?.commented)}
        isLiked={post?.isLiked}
        // onDeletePost={() => routet.push('/')}
        post={post}
        disableShortenContent
        onPostCommentSuccess={onPostCommentSuccess}
        // InlineCommentsComponent={
        //   IS_MARRY_BABY ? PostCommentComponents : undefined
        // }
        showInputComment={true}
        onEditPost={() => {
          setShowPostForm(true)
          setEditPostData(post)
        }}
        onDeletePost={onDeletePost}
      />
      <div className="sort-container">
        <LabelSorting
          color="white"
          value={(selectedSortChoice?.value || '') as LabelSortingValue}
          onChange={(v) => {
            if (v !== selectedSortChoice?.value) {
              // refetchCoralStory(v as LabelSortingValue)
              setSortChoiceValue(v as LabelSortingValue)
              fetchComment({
                page: 1,
                sortValue: v,
                isRefetch: true,
              })
            }
          }}
          className="label-sorting"
          leftLabel={f(
            { id: 'comment.count' },
            {
              count: commentCount,
            },
          )}
          rightLabel={f({ id: 'choicePopover.sort' })}
          choices={sortedChoices}
        />
      </div>
      {comments && comments.length > 0
        ? comments.map((comment) => (
            <CardReply
              isMobile={isMobile}
              key={comment.id}
              className={'post-comment'}
              comment={comment}
              post={post}
              onDeleteComment={() => {
                setComments((old: any) => {
                  return old.filter((c: any) => c.id !== comment.id)
                })
              }}
              onEditCommentSuccess={(comment) => {
                setComments((old: any) => {
                  const tmp = [...old]
                  const editCommentIdx = old.findIndex(
                    (i: any) => i.id === comment.id,
                  )
                  tmp[editCommentIdx] = comment
                  return tmp
                })
              }}
              refetchComment={refetchComment}
            />
          ))
        : null}
    </Section>
  )
}

export { PostDetail }
